import { Link } from 'react-router-dom';
import { FileText, FolderGit2, PenLine } from 'lucide-react';
import { useDashboard } from '../../hooks/use-admin';
import { formatDateShort } from '../../lib/format';
import { ErrorState, Loading } from '../../components/StatusStates';

export default function Dashboard() {
  const { data, isLoading, isError, refetch } = useDashboard();

  if (isLoading) return <Loading />;
  if (isError || !data) return <ErrorState onRetry={() => refetch()} />;

  const stats = [
    { label: '文章总数', value: data.counts.posts, icon: FileText },
    { label: '已发布', value: data.counts.publishedPosts, icon: PenLine },
    { label: '草稿', value: data.counts.draftPosts, icon: FileText },
    { label: '项目数量', value: data.counts.projects, icon: FolderGit2 },
  ];

  return (
    <>
      <div className="stat-grid">
        {stats.map((stat) => (
          <div key={stat.label} className="stat-card">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '0.5rem',
              }}
            >
              <p className="stat-label">{stat.label}</p>
              <stat.icon size={18} style={{ color: 'var(--color-ink-faint)' }} aria-hidden="true" />
            </div>
            <p className="stat-value">{stat.value}</p>
          </div>
        ))}
      </div>

      <div className="panel-grid">
        <section className="panel">
          <div className="panel-head">最近更新的文章</div>
          {data.recentPosts.length === 0 ? (
            <p className="form-hint" style={{ padding: '1rem 1.5rem' }}>
              暂无文章
            </p>
          ) : (
            data.recentPosts.map((post) => (
              <div key={post.id} className="panel-row">
                <span className="panel-row-name">{post.title}</span>
                <span className={post.status === 'published' ? 'badge badge-published' : 'badge badge-draft'}>
                  {post.status === 'published' ? '已发布' : '草稿'}
                </span>
                <span className="panel-row-time">{formatDateShort(post.updatedAt)}</span>
              </div>
            ))
          )}
        </section>

        <section className="panel">
          <div className="panel-head">最近更新的项目</div>
          {data.recentProjects.length === 0 ? (
            <p className="form-hint" style={{ padding: '1rem 1.5rem' }}>
              暂无项目
            </p>
          ) : (
            data.recentProjects.map((project) => (
              <div key={project.id} className="panel-row">
                <span className="panel-row-name">{project.name}</span>
                <span className="panel-row-time">{formatDateShort(project.updatedAt)}</span>
              </div>
            ))
          )}
        </section>
      </div>

      <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.75rem' }}>
        <Link to="/admin/posts/new" className="btn btn-primary btn-sm">
          写新文章
        </Link>
        <Link to="/admin/projects" className="btn btn-outline btn-sm">
          管理项目
        </Link>
      </div>
    </>
  );
}
